import { createNamespacer, createReducer } from "../utils/reducers";

const initialState = {
  isLoggedIn: false,
  user: null,
  userDetails: null,
  superAdminDetails: null,
  isAdminLoggedIn: false,
  autoLogoutOfUser: false,
  autoLogoutOfSuperAdmin: false,

  providerDetails: null,
  isProviderLoggedIn: false,
  autoLogoutOfProvider: false,

  //  PRENEED (added)
  preNeedDetails: null,
  isPreNeedLoggedIn: false,
  autoLogoutOfPreNeed: false,
};

const namespacer = createNamespacer("SESSION");

const handlers = {
  [namespacer("SET_IS_LOGGED_IN")]: (state: any, action: any) => {
    return {
      ...state,
      isLoggedIn:
        action.payload.value !== undefined
          ? action.payload.value
          : state.isLoggedIn,

      isAdminLoggedIn:
        action.payload.isAdminLogin !== undefined
          ? action.payload.isAdminLogin
          : state.isAdminLoggedIn,

      userDetails:
        action.payload.userDetails !== undefined
          ? action.payload.userDetails
          : state.userDetails,

      superAdminDetails:
        action.payload.superAdminDetails !== undefined
          ? action.payload.superAdminDetails
          : state.superAdminDetails,

      isProviderLoggedIn:
        action.payload.isProviderLogin !== undefined
          ? action.payload.isProviderLogin
          : state.isProviderLoggedIn,

      providerDetails:
        action.payload.providerDetails !== undefined
          ? action.payload.providerDetails
          : state.providerDetails,

      //  PRENEED (added)
      isPreNeedLoggedIn:
        action.payload.isPreNeedLogin !== undefined
          ? action.payload.isPreNeedLogin
          : state.isPreNeedLoggedIn,

      preNeedDetails:
        action.payload.preNeedDetails !== undefined
          ? action.payload.preNeedDetails
          : state.preNeedDetails,
    };
  },

  [namespacer("SET_AUTO_LOGOUT")]: (state: any, action: any) => {
    return {
      ...state,
      autoLogoutOfUser:
        action.payload.userType === "user"
          ? action.payload.autoLogoutOfUser
          : state.autoLogoutOfUser,

      autoLogoutOfSuperAdmin:
        action.payload.userType === "superAdmin"
          ? action.payload.autoLogoutOfSuperAdmin
          : state.autoLogoutOfSuperAdmin,

      autoLogoutOfProvider:
        action.payload.userType === "provider"
          ? action.payload.autoLogoutOfProvider
          : state.autoLogoutOfProvider,

      //  PRENEED (added)
      autoLogoutOfPreNeed:
        action.payload.userType === "preNeed"
          ? action.payload.autoLogoutOfPreNeed
          : state.autoLogoutOfPreNeed,
    };
  },

  [namespacer("UPDATE_USER_DETAILS")]: (state: any, action: any) => {
    return {
      ...state,
      userDetails: {
        ...state.userDetails,
        user: {
          ...(state.userDetails?.user || {}),
          ...action.payload,
        },
      },
    };
  },

  [namespacer("UPDATE_PROVIDER_DETAILS")]: (state: any, action: any) => {
    const profilePhoto =
      action.payload?.profile_photo ||
      action.payload?.profileImage ||
      action.payload?.profilePhoto ||
      state.providerDetails?.profile_photo ||
      state.providerDetails?.user?.profile_photo ||
      "";

    return {
      ...state,
      providerDetails: {
        ...state.providerDetails,
        ...action.payload,
        profile_photo: profilePhoto,
        profileImage: profilePhoto,
        profilePhoto: profilePhoto,
        user: {
          ...(state.providerDetails?.user || {}),
          ...action.payload,
          profile_photo: profilePhoto,
          profileImage: profilePhoto,
          profilePhoto: profilePhoto,
        },
      },
    };
  },

  [namespacer("UPDATE_PRENEED_DETAILS")]: (state: any, action: any) => {
    const profilePhoto =
      action.payload?.profile_photo ||
      action.payload?.profileImage ||
      action.payload?.profilePhoto ||
      state.preNeedDetails?.profile_photo ||
      state.preNeedDetails?.user?.profile_photo ||
      "";

    return {
      ...state,
      preNeedDetails: {
        ...state.preNeedDetails,
        ...action.payload,
        profile_photo: profilePhoto,
        profileImage: profilePhoto,
        profilePhoto: profilePhoto,
        user: {
          ...(state.preNeedDetails?.user || {}),
          ...action.payload,
          profile_photo: profilePhoto,
          profileImage: profilePhoto,
          profilePhoto: profilePhoto,
        },
      },
    };
  },

  [namespacer("UPDATE_SUPER_ADMIN_DETAILS")]: (state: any, action: any) => {
    let profilePhoto = "";
    if (action.payload?.profile_photo !== undefined) {
      profilePhoto = action.payload.profile_photo;
    } else if (action.payload?.profileImage !== undefined) {
      profilePhoto = action.payload.profileImage;
    } else if (action.payload?.profilePhoto !== undefined) {
      profilePhoto = action.payload.profilePhoto;
    } else {
      profilePhoto =
        state.superAdminDetails?.profile_photo ||
        state.superAdminDetails?.user?.profile_photo ||
        "";
    }

    return {
      ...state,
      superAdminDetails: {
        ...state.superAdminDetails,
        ...action.payload,
        profile_photo: profilePhoto,
        profileImage: profilePhoto,
        profilePhoto: profilePhoto,
        user: {
          ...(state.superAdminDetails?.user || {}),
          ...action.payload,
          profile_photo: profilePhoto,
          profileImage: profilePhoto,
          profilePhoto: profilePhoto,
        },
      },
    };
  },
};

const reducer = createReducer(initialState, handlers, ["SESSION"]);

export default reducer;
